import React from 'react';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import MASpinner from '../../components/common/MASpinner';
import { addToast } from '../../lib/redux/actions/toast';
import { invoiceSingleFetch, invoiceSingleUnload } from '../../lib/redux/actions/invoices';
import InvoiceSingle from './InvoiceSingle';
import Helmet from 'react-helmet';
import { contactRecordRemove, contactRecordSingleCreate, contactRecordSingleUpdate } from '../../lib/redux/actions/contactRecords';
import { invoiceNotesFetch } from '../../lib/redux/actions/invoiceNote';
import { patientNoteSetPopup, patientNotesFetch, patientNotesUnload } from '../../lib/redux/actions/patientNotes';
import { patientIdFromIri } from '../../lib/helper/patientFilters';
import { hasPopupNotes } from '../../lib/helper/patientNotes';
import { isChaserOutsourcer, isOutsourcer, isStaff } from '../../lib/helper/authorisation';
import PatientPopupNotesModal from '../../components/Patient/PatientPopupNotesModal';

const mapStateToProps = (state) => ({
  ...state.invoices,
  ...state.stats,
  ...state.patientNotes,
});

const mapDispatchToProps = {
  invoiceSingleFetch,
  invoiceSingleUnload,
  invoiceNotesFetch,
  patientNotesFetch,
  patientNotesUnload,
  patientNoteSetPopup,
  contactRecordSingleUpdate,
  contactRecordSingleCreate,
  contactRecordRemove,
  addToast,
};

//const getUISettings = () => {
//  let uiSettings = window.localStorage.getItem('invoiceUISettings');
//  return null === uiSettings ? {} : JSON.parse(uiSettings);
//};

class InvoiceSingleContainer extends React.Component {
  constructor(props) {
    super(props);

    // MED-922. Whether the patient-note pop-up has been closed *on this view*. Nothing else
    // remembers it: it resets when the invoice changes, and on the next visit the pop-up fires
    // again. That is the ruling - it keeps popping until somebody clears the flag on the note.
    this.state = { popupDismissed: false };

    this.initialLoad();
  }

  initialLoad() {
    this.props.invoiceSingleUnload();
    this.props.invoiceSingleFetch(this.props.match.params.id.replace('CC', ''));
  }

  componentDidMount() {
    this.initialLoad();
  }

  componentDidUpdate(prevProps) {
    const { invoice, invoiceNotesFetch } = this.props;
    // if just the invoice number changes in the url - force a reload
    if (this.props?.match?.params?.id !== prevProps?.match?.params?.id && prevProps?.match?.params?.id !== false) {
      this.initialLoad();
    }

    if (prevProps.invoice !== invoice && invoice?.id) {
      //      console.log('cdu: fetch notes');
      invoiceNotesFetch(invoice?.id);

      // MED-922. The patient's notes come from the register, not from the invoice - and only
      // for internal users, who are the only ones the endpoint admits. A consultant-side user
      // gets neither the fetch nor the pop-up, which is the whole point of the exception.
      const patientId = patientIdFromIri(invoice?.patient);
      if (patientId && this.canSeePatientNotes()) {
        this.setState({ popupDismissed: false });
        this.props.patientNotesFetch(patientId);
      } else {
        this.props.patientNotesUnload();
      }
    }
  }

  componentWillUnmount() {
    this.props.invoiceSingleUnload();
    this.props.patientNotesUnload();
  }

  canSeePatientNotes() {
    return isStaff() || isOutsourcer() || isChaserOutsourcer();
  }

  /**
   * The store may still hold the previous patient's notes for a moment; only trust it once it is
   * tagged with this invoice's patient.
   */
  patientNotesForThisInvoice() {
    const { invoice, patientNotes, patientNotesForPatientId } = this.props;
    const patientId = patientIdFromIri(invoice?.patient);

    return patientId && Number(patientNotesForPatientId) === Number(patientId) ? patientNotes : [];
  }

  render() {
    const {
      invoice,
      isFetchingInvoice,
      isUpdatingInvoice = false,
      contactRecordSingleCreate,
      contactRecordSingleUpdate,
      contactRecordRemove,
      invoiceNotes = [],
    } = this.props;
    if (!isFetchingInvoice && !invoice) {
      return (
        <Card>
          <Card.Header>
            <div className="d-flex justify-content-between">Not Found</div>
          </Card.Header>
          <Card.Body>
            <p>The invoice you are looking for cannot be found.</p>
          </Card.Body>
        </Card>
      );
    }
    if (isFetchingInvoice && !invoice) {
      return <MASpinner />;
    }
    //    console.log({ invoice });
    //    let uiSettings = getUISettings();
    //
    //    const switchUI = () => {
    //      let uiSettings = getUISettings();
    //      uiSettings[invoice.consultant.id] = !uiSettings[invoice.consultant.id];
    //      window.localStorage.setItem('invoiceUISettings', JSON.stringify(uiSettings));
    //      this.forceUpdate();
    //    };

    return (
      <>
        <Helmet>
          <title>{`Invoice ${invoice.invoiceNo} for ${invoice.patientFirstName} ${invoice.patientLastName}`}</title>
        </Helmet>
        {/*<div className={'mb-2 text-right'}>*/}
        {/*  <button className="btn btn-secondary btn-xs" onClick={() => switchUI()}>*/}
        {/*    Switch UI*/}
        {/*  </button>*/}
        {/*</div>*/}
        {/* Every consultant gets the modern invoice screen (MED-967).

            This used to fork on consultant.useAutomatedChasing, which sent 18 consultants to
            OldInvoiceSingleRefOnly - a screen whose only unique feature is the credit control
            action form, and every action on it has been dead since 2024-09-27. They also missed
            the Ledger tab, on 35 invoices that have ledger rows nobody could see.

            The flag keeps its real job of gating the chaser (InvoiceRepository:263). Only the
            choice of screen stops depending on it, so no invoice chases differently. */}
        <PatientPopupNotesModal
          notes={this.patientNotesForThisInvoice()}
          patientName={`${invoice.patientFirstName || ''} ${invoice.patientLastName || ''}`.trim()}
          show={!this.state.popupDismissed && hasPopupNotes(this.patientNotesForThisInvoice())}
          onDismiss={() => this.setState({ popupDismissed: true })}
          onStopPopup={(noteId) => this.props.patientNoteSetPopup(noteId, false)}
        />
        <InvoiceSingle
          isUpdatingInvoice={isUpdatingInvoice}
          invoice={invoice}
          invoiceNotes={invoiceNotes}
          patientNotes={this.patientNotesForThisInvoice()}
          canSeePatientNotes={this.canSeePatientNotes()}
          addContactRecord={(c) => {
            contactRecordSingleCreate(c).then(() => {
              this.props.invoiceSingleFetch(this.props.match.params.id.replace('CC', ''));
            });
          }}
          updateContactRecord={(c) => {
            contactRecordSingleUpdate(c, c.id).then(() => {
              this.props.invoiceSingleFetch(this.props.match.params.id.replace('CC', ''));
            });
          }}
          removeContactRecord={(c) => {
            contactRecordRemove(c).then(() => {
              this.props.invoiceSingleFetch(this.props.match.params.id.replace('CC', ''));
            });
          }}
        />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceSingleContainer);
